<script lang="ts">
	import { renderAboutParagraph } from '@shared/site-content';
	import type { SiteConfig } from '$lib/types';

	interface Props {
		site: SiteConfig;
	}

	let { site }: Props = $props();
</script>

<section id="about" class="section about" aria-labelledby="about-heading">
	<div class="container section-grid">
		<div class="section-intro">
			<p class="eyebrow">Profile</p>
			<h2 id="about-heading">About</h2>
			<div class="section-rule" aria-hidden="true"></div>
		</div>
		<div class="section-body">
			{#each site.about.paragraphs as paragraph, index}
				<p class:about-close={index === site.about.paragraphs.length - 1}>
					{@html renderAboutParagraph(paragraph, site.name)}
				</p>
			{/each}
		</div>
	</div>
</section>
